import { styled } from '@material-ui/core';
import { FileCopyOutlined } from '@material-ui/icons';

import { COLORS } from 'theme/constants';

export const FileCopyOutlinedIcon = styled(FileCopyOutlined)({
  color: COLORS.greyIcon,
});
